// Formatos de fecha del chat de tickets

export const horaCorta = (fecha) => new Date(fecha).toLocaleTimeString('es-ES', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
});

export const fechaCompleta = (fecha) => new Date(fecha).toLocaleString('es-ES', {
    day: '2-digit',
    month: 'long',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
});

/**
 * Hora del mensaje en lenguaje natural mientras es reciente ("hace 5 min") y
 * como hora normal a partir de ahí. La fecha exacta va siempre en el title.
 */
export const horaRelativa = (fecha) => {
    const marca = new Date(fecha).getTime();
    if (Number.isNaN(marca)) return '';

    const segundos = Math.round((Date.now() - marca) / 1000);

    if (segundos < 45) return 'ahora';
    if (segundos < 90) return 'hace 1 min';
    if (segundos < 3600) return `hace ${Math.round(segundos / 60)} min`;

    return horaCorta(fecha);
};

/** Los mensajes recientes necesitan refrescar su "hace X min"; los viejos no. */
export const esReciente = (fecha) => (Date.now() - new Date(fecha).getTime()) < 3600 * 1000;
